import axios from 'axios'

export const getAllServices = (params) => {
  return axios.get('services', {params: params})
}

export const getServices = (id, params) => {
  return axios.get('services/' + id, {params: params})
}

export const addService = (data) => {
  return axios.post('services', data)
}

export const editService = (id, data) => {
  return axios.put('services/' + id, data)
}

export const deleteService = (id) => {
  return axios.delete('services/' + id)
}

export const restoreService = (id) => {
  return axios.post('services/' + id + '/restore', {})
}



// WEBPACK FOOTER //
// ./src/api/service.js